import React, { useState, useRef } from "react";
import "./ContactForm.scss";

// Components
import Input from "components/UI/Form/Input/Input";
import Button from "components/UI/Form/Button/Button";
import TextArea from "components/UI/Form/TextArea/TextArea";

// Libraries & Packages
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";

// Utils
import { ToastProperties } from "utils/toast/ToastProperties";

function ContactForm() {
  //State
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  // Ref
  const contactForm = useRef();

  // Functions
  const handleSubmit = (e) => {
    console.log(name, email, message);

    // Form Validations
    e.preventDefault();
    if (!name || !email || !message) {
      return toast.error("Please enter all the fields!", ToastProperties);
    }

    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      return toast.error("Invalid Email", ToastProperties);
    }

    // EmailJS
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        contactForm.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          toast.success(
            "Thank you for reaching out! Your message has been successfully submitted.",
            ToastProperties
          );
        },
        (error) => {
          toast.error(
            "Oops! Something went wrong. Please try again!",
            ToastProperties
          );
        }
      );
  };

  return (
    <form className="contactForm" ref={contactForm}>
      {/* Name */}
      <div className="contactForm__field">
        <Input
          placeholder="Enter Your Name"
          label="Name"
          name="input__name"
          width="100%"
          borderRadius="none"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      {/* Email */}
      <div className="contactForm__field">
        <Input
          placeholder="Enter Your Email"
          label="Email"
          name="input__email"
          width="100%"
          borderRadius="none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      {/* Message */}
      <div className="contactForm__field">
        <TextArea
          label="Message"
          name="input__message"
          placeholder="Enter Your Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </div>
      {/* Submit */}
      <div className="contactForm__button">
        <div
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          <Button>Submit</Button>
        </div>
      </div>
    </form>
  );
}

export default ContactForm;
